angular.module('aprima-bridge').factory('PrmBridge', ['XamarinBridge', '_', function (XamarinBridge, _) {
    'use strict';

    var prmBridge = _.cloneDeep(XamarinBridge);

    //add properties unique to prm here

    return prmBridge;
}]);
